function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M467.6,0.8H142.4C117.9,0.8,98,20.7,98,45.2V98H22.2C10,98,0,108,0,120.2v369.5C0,502,10,512,22.2,512h369.6 c12.3,0,22.2-10,22.2-22.2v-81.3h-1c3.1-1.9,6-4.1,8.5-6.7l77.5-77.5c8.2-8.3,12.9-19.6,12.9-31.4V45.2 C512,20.7,492.1,0.8,467.6,0.8z M29.6,482.4V142.3c0-8.1,6.6-14.7,14.8-14.7H98v242.9c0,24.5,19.9,44.4,44.4,44.4h242.1v67.6H29.6 V482.4z M478.1,303.3l-77.5,77.5c-1.9,1.9-4.3,3.2-6.9,3.9v-88.3H482C481.4,299.1,480,301.5,478.1,303.3z M482.4,267h-96.1 c-12.2,0-22.2,9.9-22.2,22.2v96.1H142.4c-8.2,0-14.8-6.6-14.8-14.8V45.2c0-8.2,6.6-14.8,14.8-14.8h325.3c8.1,0,14.7,6.6,14.7,14.8 V267z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M406.4,103.5h-202c-5.6,0-10.1,3.6-10.1,8.1v16.2c0,4.4,4.5,8.1,10.1,8.1h201.9c5.6,0,10.1-3.6,10.1-8.1v-16.2 C416.5,107.1,412,103.5,406.4,103.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M303.2,281.4H198.7c-2.9,0-5.2,3.6-5.2,8.1v16.2c0,4.4,2.3,8.1,5.2,8.1h104.4c2.9,0,5.2-3.6,5.2-8.1v-16.2 C308.4,285,306.1,281.4,303.2,281.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M406.4,192.4h-202c-5.6,0-10.1,3.6-10.1,8.1v16.2c0,4.4,4.5,8.1,10.1,8.1h201.9c5.6,0,10.1-3.6,10.1-8.1v-16.2 C416.5,196,412,192.4,406.4,192.4z"
}));

function SvgOther(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.c15541df.svg";
export { ForwardRef as ReactComponent };